<vectronic-card
  class="user-data-dialog"
  [title]="data.title"
  [displayClose]="true"
  (closed)="dialogRef.close()"
>
  <ng-container body>
    <p class="user-data-dialog__wrap-data">
      {{ data.data }}
    </p>
    <mat-dialog-actions class="user-data-dialog__button-container">
      <button mat-button (click)="copyToClipboard()" color="accent">
        <mat-icon>file_copy</mat-icon>
        Copy To Clipboard
      </button>
      <button mat-button color="warn" mat-dialog-close>
        <mat-icon>cancel</mat-icon>
        Cancel
      </button>
    </mat-dialog-actions>
  </ng-container>
</vectronic-card>
